import { render, staticRenderFns } from "./UnitSettings.vue?vue&type=template&id=01d36566&scoped=true"
import script from "./UnitSettings.vue?vue&type=script&lang=js"
export * from "./UnitSettings.vue?vue&type=script&lang=js"
import style0 from "./UnitSettings.vue?vue&type=style&index=0&id=01d36566&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01d36566",
  null
  
)

export default component.exports